const formValidationFields = [{ title: 'title' }];

export { formValidationFields };
